import { useTranslation } from "react-i18next";
import { InformationPage } from "~/common/components/informationPage/InformationPage";
import classNames from "classnames";
import classes from "~/features/selectionAssistant/gearbox/components/ResultsSection/components/ResultList/ResultList.module.less";
import { IMG_EMPTY_STATE } from "~/utils/url/staticResources";
import { URL_CONTACT_US } from "~/utils/url/staticUrls";

export const NoResults = ({ className }: { className?: string }) => {
  const { t } = useTranslation();

  return (
    <InformationPage.CenterContents className={classNames(className, classes.noResults)}>
      <InformationPage.Title>{t("page.sa.gearbox.results.empty.title")}</InformationPage.Title>
      <InformationPage.Image src={IMG_EMPTY_STATE} alt={""} />
      <InformationPage.Subtitle>{t("page.sa.gearbox.results.empty.subtitle")}</InformationPage.Subtitle>
      <InformationPage.CtaButton href={URL_CONTACT_US}>{t("page.sa.gearbox.btn.contactUs")}</InformationPage.CtaButton>
    </InformationPage.CenterContents>
  );
};
